// @ts-nocheck
export default function Interlude() {
  return (
    <section aria-label="Transition" className="interlude-sec">
      <div className="interlude-inner">
        <div className="ey rev">That&apos;s the process</div>
        <h2 className="interlude-h rev d1">
          Four steps on paper.{" "}<br />
          <em>One product in motion.</em>
        </h2>
        <p className="interlude-p rev d2">
          Below, the same flow, step by step, on a sample vendor agreement —
          the order the product runs it in, illustrated.
        </p>
        <div aria-hidden="true" className="interlude-rule rev d3">
          <span className="interlude-rule-line"></span>
          <span className="interlude-rule-dot"></span>
          <span className="interlude-rule-line"></span>
        </div>
      </div>
    </section>
  );
}
